export const SousDispositif = ['ProA', 'ProAFne'] as const
export type SousDispositif = (typeof SousDispositif)[number]

/** Sous dispositifs disponibles à la créations */
export const SousDispositifDisponible: SousDispositif[] = [...new Set<SousDispositif>([
  'ProA', 'ProAFne'
])] as const

export type SousDispositifDisponible = (typeof SousDispositifDisponible)[number]

export const SousDispositifLibelle: { [key in SousDispositif]: string } = {
  ProA: 'Contrat PRO-A',
  ProAFne: 'Contrat PRO-A FNE',
} as const
